var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"wrapper-footer d-flex justify-center align-center",attrs:{"height":"30px"}},[_c('span',{staticClass:"text-footer"},[_vm._v(" Copyright © 2021 All rights reserved. Rinen | Privacy Policy ")])])}
var staticRenderFns = []

export { render, staticRenderFns }